// @flow
/* eslint jsx-a11y/no-static-element-interactions:0 */
import React, { Component } from 'react';
import Button from 'app/common/react/components/growth/unauth/Button/Button';
import { Box } from 'gestalt';

type LoginButtonProps = {|
  buttonText: string,
  fullWidth?: boolean,
  link?: string,
  onClick: (event: SyntheticEvent<>) => void,
  title?: string,
  titleStylesOverride: Object,
  useSmallButton?: boolean,
|};

type State = {|
  hover: boolean,
|};

const styles = {
  header: {
    color: '#5a5a5a',
    fontWeight: 500,
    fontSize: '12px',
  },
  button: {
    width: '160px',
    fontSize: '14px',
    padding: '10px 20px',
  },
};

export default class LoginButton extends Component<LoginButtonProps, State> {
  state: State = {
    hover: false,
  };

  toggleHover = () => {
    this.setState({ hover: !this.state.hover });
  };

  render() {
    const {
      buttonText,
      fullWidth,
      link,
      onClick,
      title,
      titleStylesOverride,
      useSmallButton,
    } = this.props;
    let titleStyles = styles.header;
    if (titleStylesOverride) {
      titleStyles = { ...titleStyles, ...titleStylesOverride };
    }
    const buttonStyle = fullWidth
      ? { ...styles.button, width: '100%', marginTop: '0' }
      : styles.button;
    let button = (
      <Button
        className={'lightGray'}
        href={link}
        onClick={onClick}
        styleOverrides={buttonStyle}
        type="button"
      >
        {buttonText}
      </Button>
    );
    let wrapperDivStyles = {};
    if (useSmallButton) {
      titleStyles = { ...titleStyles, float: 'left' };
      wrapperDivStyles = {
        margin: '0 auto 5px',
        width: 'fit-content',
        alignItems: 'baseline',
      };
      const buttonStyle = this.state.hover
        ? { cursor: 'pointer', marginLeft: '5px', borderBottom: '0.5px solid #8a8a8a' }
        : { cursor: 'pointer', marginLeft: '5px' };
      button = (
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        <Box onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}>
          <a onClick={onClick} style={buttonStyle}>
            {buttonText}
          </a>
        </Box>
      );
      /* eslint-enable jsx-a11y/click-events-have-key-events */
    }
    return (
      <div style={wrapperDivStyles}>
        {title && <h5 style={titleStyles}>{title}</h5>}
        {button}
      </div>
    );
  }
}
